import { LiloDrugSearchResponse } from '@lib/core/models/protocol.interface';

import { PersonalDoctorMetadata, PharmacologicalItemMetaData, Prescription, PrescriptionTypes, ResponseMorionItem, ServiceMetadata } from '../models/prescription.interface';
import { getMedicationFullName, getMedicationInn, getMedicationUniqueForms } from './medication-name.function';

export function prescriptionToRequestBody(
  prescription: Prescription,
  status: string,
  reason: string,
  completedInAppointment: boolean = false,
  completionReason: string | null = null
) {
  const metadata = prescription.metadata;
  let metadataRequestBody: PharmacologicalItemMetaData | ServiceMetadata | PersonalDoctorMetadata;
  if (prescription.type === PrescriptionTypes.Drugs) {
    const medicationMetadata = metadata as PharmacologicalItemMetaData;
    const morion_items = medicationMetadata.morion_items ? (JSON.parse(medicationMetadata.morion_items) as ResponseMorionItem[]) : [];
    const trademarks = JSON.stringify(adaptTrademarksFromPrescription(morion_items));
    metadataRequestBody = {
      ...medicationMetadata,
      inn: getMedicationInn(medicationMetadata),
      inn_ua: medicationMetadata.morion_substance || medicationMetadata.inn,
      form: getMedicationUniqueForms(medicationMetadata).join(', '),
      single_dose: medicationMetadata.single_dose || '1',
      frequency: medicationMetadata.frequency ?? '1',
      duration: medicationMetadata.duration || '1',
      trademarks: trademarks,
    } as PharmacologicalItemMetaData;
    delete metadataRequestBody.morion_items;
    delete metadataRequestBody.morion_substance;
  } else {
    metadataRequestBody = metadata;
  }
  const name = prescription.type === PrescriptionTypes.Drugs
    ? getMedicationFullName(metadata as PharmacologicalItemMetaData)
    : prescription.name;
  return {
    id: prescription.id,
    type: prescription.type,
    name: name,
    startDate: prescription.startDate,
    endDate: prescription.endDate,
    guaranteeStatus: status,
    reason: reason,
    metadata: metadataRequestBody,
    completedInAppointment: completedInAppointment,
    completionReason: completionReason,
  };
}

export function adaptTrademarksFromPrescription(morionItems: ResponseMorionItem[]): LiloDrugSearchResponse[] {
  return morionItems.map(item => {
    return {
      code: item.Code.toString(),
      formUa: item.FormUa,
      nameFullUa: item.NameFullUa,
      morionInnUa: '',
      morionInnEn: '',
      identifier: '',
      substanceQuantity: item.SubsctanceQuantity,
      substanceQuantities: item.SubstanceQuantities ? item.SubstanceQuantities : [],
      quantityInPackage: item.QuantityInPackage,
      ehealthShortSearchString: '',
      helsiSearchString: '',
      isRecommended: false,
    };
  });
}
